import Fetch from '@/api';
import router from '@/router';
import { MessageBox } from 'element-ui';

const state = {
  unDownloadCount: 0
};

const mutations = {
  ADD_DOWNLOAD_COUNT(state) {
    state.unDownloadCount = state.unDownloadCount + 1;
  },
  RESET_DOWNLOAD_COUNT(state) {
    state.unDownloadCount = 0;
  }
};

const actions = {
  exportFile({ commit }, params) {
    const { exportType, callback, retryCallback, ...rest } = params;

    return Fetch[exportType](rest).then(
      res => {
        // todo 下载成功，提示去下载中心
        commit('ADD_DOWNLOAD_COUNT');
        callback && callback();
        if (!!res.message) {
          retryCallback && retryCallback(res.message);
          return;
        }
        return MessageBox.confirm('文件正在生成中，请前往下载中心进行下载', '数据导出成功', {
          center: true,
          confirmButtonText: '前往下载中心下载',
          cancelButtonText: '稍后下载',
          beforeClose(action, instance, done) {
            switch (action) {
              case 'confirm':
                done();
                router.push('/download');
                break;
              case 'cancel':
              case 'close':
                done();
                break;
            }
          }
        });
      },
      ({ code: errCode, message }) => {
        const handleErrorMap = {
          // 重复导出
          EXPORT_REPEAT() {
            return MessageBox.alert('同类型数据不可同时导出多份，请前往下载中心查看正在导出的任务', '数据导出失败', {
              center: true,
              customClass: 'hint',
              confirmButtonText: '前往下载中心',
              beforeClose(action, instance, done) {
                switch (action) {
                  case 'confirm':
                    router.push('/download');
                    done();
                    break;
                  case 'cancel':
                  case 'close':
                    done();
                    break;
                }
              }
            });
          },
          // 导出数量超限
          EXPORT_LIMIT() {
            return MessageBox.alert(
              `导出数据量过大会导致导出失败，建议调整导出范围，${message || '本类型建议导出1000条以下'}`,
              '数据导出失败',
              {
                center: true,
                customClass: 'hint',
                confirmButtonText: '前往下载中心',
                showConfirmButton: false,
                beforeClose(action, instance, done) {
                  switch (action) {
                    case 'confirm':
                      router.push('/download');
                      done();
                      break;
                    case 'cancel':
                    case 'close':
                      done();
                      break;
                  }
                }
              }
            );
          }
        };
        callback && callback();
        handleErrorMap[errCode]();
      }
    );
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
